import React from 'react'
import SvgIcon, { SvgIconProps } from 'components/Luxkit/SvgIcon'

function LineBedDoubleAltIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M20.14 10.3999v-4.7c0-1.2-1-2.3-2.2-2.3H6.14c-1.2 0-2.2 1-2.2 2.3v4.7c-1.1.4-1.9 1.6-1.9 2.9v4.5c0 .5.4 1 .9 1h1v.9c0 .5.4 1 .9 1s.9-.4.9-1v-.9h12.5v.9c0 .5.4 1 .9 1s.9-.4.9-1v-.9h1c.5 0 .9-.4.9-1v-4.5c.1-1.4-.7-2.5-1.8-2.9Zm-7.2-1.2c0-.3.2-.5.4-.5h1.8c.2 0 .4.2.4.5v1h-2.6v-1Zm-4.4 0c0-.3.2-.5.4-.5h1.8c.2 0 .4.2.4.5v1h-2.6v-1Zm6.6-2.4h-1.8c-.5 0-1 .2-1.3.5-.4-.3-.8-.5-1.3-.5h-1.8c-1.3 0-2.3 1.1-2.3 2.4v1h-.9v-4.5c0-.2.2-.4.3-.4h11.9c.2 0 .3.1.3.4v4.5h-.9v-1c.1-1.3-.9-2.4-2.2-2.4Zm5.1 6.5v3.5H3.84v-3.5c0-.7.5-1.2 1.1-1.2h14.2c.6 0 1.1.5 1.1 1.2Z"/>
  </SvgIcon>
}

export default LineBedDoubleAltIcon
